import { useContext } from 'react';
import { MediaUploadContext } from 'contexts/mediaUpload';

const useUploadMedia = () => {
  const { uploadFiles } = useContext(MediaUploadContext);
  return uploadFiles;
};

export default useUploadMedia;
